// Custom SVG Icons for Core Values
import React from 'react';

interface IconProps {
  className?: string;
  primaryColor?: string;
  secondaryColor?: string;
  accentColor?: string;
}

export const InnovationIcon: React.FC<IconProps> = ({ 
  className = 'w-12 h-12',
  primaryColor = 'currentColor',
  secondaryColor = '#a259ff',
  accentColor = '#00ff94'
}) => (
  <svg className={className} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="24" cy="24" r="22" fill="none" stroke={primaryColor} strokeWidth="2" />
    <path d="M24 12v7l6 4-6 4v7" stroke={secondaryColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="24" cy="24" r="4" fill={accentColor} />
    <path d="M18 36h12" stroke={primaryColor} strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const QualityIcon: React.FC<IconProps> = ({ 
  className = 'w-12 h-12',
  primaryColor = 'currentColor',
  secondaryColor = '#a259ff',
  accentColor = '#00ff94'
}) => (
  <svg className={className} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="8" y="8" width="32" height="32" rx="4" fill="none" stroke={primaryColor} strokeWidth="2" />
    <path d="M16 28l4-4 4 4 8-8" stroke={accentColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="36" cy="12" r="2" fill={secondaryColor} />
    <path d="M24 12h8" stroke={primaryColor} strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const CollaborationIcon: React.FC<IconProps> = ({ 
  className = 'w-12 h-12',
  primaryColor = 'currentColor',
  secondaryColor = '#a259ff',
  accentColor = '#00ff94'
}) => (
  <svg className={className} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="24" r="6" fill="none" stroke={primaryColor} strokeWidth="2" />
    <circle cx="32" cy="24" r="6" fill="none" stroke={primaryColor} strokeWidth="2" />
    <path d="M16 30c0 4.418 3.582 8 8 8s8-3.582 8-8" stroke={secondaryColor} strokeWidth="2" fill="none" />
    <path d="M32 18c0-4.418-3.582-8-8-8s-8 3.582-8 8" stroke={accentColor} strokeWidth="2" fill="none" />
    <circle cx="16" cy="18" r="2" fill={secondaryColor} />
    <circle cx="32" cy="30" r="2" fill={accentColor} />
  </svg>
);

export const IntegrityIcon: React.FC<IconProps> = ({ 
  className = 'w-12 h-12',
  primaryColor = 'currentColor',
  secondaryColor = '#a259ff',
  accentColor = '#00ff94'
}) => (
  <svg className={className} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="12" y="8" width="24" height="32" rx="4" fill="none" stroke={primaryColor} strokeWidth="2" />
    <path d="M24 16v16" stroke={secondaryColor} strokeWidth="2" strokeLinecap="round" />
    <path d="M16 24h16" stroke={secondaryColor} strokeWidth="2" strokeLinecap="round" />
    <circle cx="24" cy="24" r="6" fill="none" stroke={accentColor} strokeWidth="2" />
    <path d="M24 20v8" stroke={accentColor} strokeWidth="2" strokeLinecap="round" />
  </svg>
);
